import { Flag, TrendingUp, Warehouse, Dices, Repeat, Coins, Gem, Crown, Lock } from "lucide-react";

const ICONS = {
  first_ride: Flag,
  bull_rider: TrendingUp,
  ranch_hand: Warehouse,
  high_roller: Dices,
  steady_saddle: Repeat,
  gold_rush: Coins,
  diamond_spurs: Gem,
  trail_boss: Crown,
};

const BadgeStamp = ({ badge }) => {
  const Icon = ICONS[badge.id] || Flag;
  return (
    <div className={`badge-stamp ${badge.earned ? "earned" : "locked"}`} data-testid={`badge-${badge.id}`} title={badge.description}>
      <div className="badge-seal">
        <Icon size={26} strokeWidth={2.2} />
        {!badge.earned && <Lock className="badge-lock" size={12} />}
      </div>
      <p className="badge-name">{badge.name}</p>
      <p className="badge-desc">{badge.description}</p>
    </div>
  );
};

export const BadgeShelf = ({ badges = [] }) => {
  const earned = badges.filter((b) => b.earned).length;
  return (
    <section className="badge-shelf" data-testid="badge-shelf">
      <div className="section-header">
        <h3 className="section-title">Rodeo Badges</h3>
        <span className="badge-count" data-testid="badge-count">{earned} / {badges.length} earned</span>
      </div>
      <div className="badge-grid">
        {badges.map((b) => <BadgeStamp key={b.id} badge={b} />)}
      </div>
    </section>
  );
};

export const NewBadgesBanner = ({ badges = [] }) => {
  if (!badges.length) return null;
  return (
    <div className="new-badges-banner" data-testid="new-badges-banner">
      <p className="new-badges-title">New badge{badges.length > 1 ? "s" : ""} earned</p>
      <div className="new-badges-row">
        {badges.map((b) => <BadgeStamp key={b.id} badge={{ ...b, earned: true }} />)}
      </div>
    </div>
  );
};
